import { UIFareRulePolicy } from "@flights/types";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { isOfMetaOrigin } from "../../../../../../../utils/marketing-url-params.js";
const useFareRulesStatusInfoController = (flight) => {
    const i18n = useI18n();
    return {
        header: i18n.trans(t("flights_details_airline_policy_header")),
        fareRulesContent: !isOfMetaOrigin() &&
            !!flight.fareRulesStatus &&
            !!flight.fareRulesStatus.policy &&
            flight.fareRulesStatus.areAllCarriersIdentical
            ? getPolicyCopy(flight.fareRulesStatus.legs[0], flight.fareRulesStatus.policy, flight.fareRulesStatus.areAllCarriersIdentical)
            : undefined
    };
};
const FARE_RULE_POLICY_TO_COPY = {
    [UIFareRulePolicy.REFUNDABLE_AND_CHANGEABLE]: [
        "flights_details_airline_policy_1",
        "flights_details_airline_policy_1_multi"
    ],
    [UIFareRulePolicy.REFUNDABLE]: ["flights_details_airline_policy_2", "flights_details_airline_policy_2_multi"],
    [UIFareRulePolicy.CHANGEABLE]: ["flights_details_airline_policy_3", "flights_details_airline_policy_3_multi"],
    [UIFareRulePolicy.NOT_REFUNDABLE_OR_CHANGEABLE]: [
        "flights_details_airline_policy_4",
        "flights_details_airline_policy_4_multi"
    ],
    [UIFareRulePolicy.NOT_REFUNDABLE]: ["flights_details_airline_policy_5", "flights_details_airline_policy_5_multi"],
    [UIFareRulePolicy.NOT_CHANGEABLE]: ["flights_details_airline_policy_6", "flights_details_airline_policy_6_multi"]
};
const getPolicyCopy = (fareRuleStatus, policy, isSingleAirline) => {
    const copy = FARE_RULE_POLICY_TO_COPY[policy]?.[isSingleAirline ? 0 : 1];
    if (!copy)
        throw Error(`Unsupported policy index: ${policy}`);
    return { copyTag: copy, carrierName: fareRuleStatus.carrierName };
};
export default useFareRulesStatusInfoController;
